import resources from '../resource.js';

const baseDomain = process.env.VUE_APP_ENDPOINT;
const baseUrl = `${baseDomain}/api/`;
const resource = 'contact';

export default {
    index(page = 1, per_page = 15, order_column = 'id', order_direction = 'desc', search = '') {
        return resources.get(`${resource}?page=${page}&per_page=${per_page}&order_column=${order_column}&order_direction=${order_direction}&search=${search}`);
    },
    show(id) {
        return resources.get(`${resource}/${id}`);
    },
    store() {
        return `${baseUrl}${resource}`
    },
    update(id) {
        return `${baseUrl}${resource}/${id}`
    },
    destroy(id) {
        return resources.delete(`${resource}/${id}`);
    },
    note(id) {
        return `${baseUrl}${resource}/${id}/notes`
    },
    
}
